// extracted by mini-css-extract-plugin
export default {"template-box":"index_template-box__jSPOH"};